import { render } from "./FinalABCList.vue?vue&type=template&id=064d79ce&ts=true"
import script from "./FinalABCList.vue?vue&type=script&lang=ts"
export * from "./FinalABCList.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__